import { configureStore } from "@reduxjs/toolkit";

import {
  cartReducer,
  bestSellers,
  classification,
  products,
  user,
  itemPriceAfterDiscount,
  recentViews,
} from "./slices";
import brand from "./slices/brandSlice";
import favorites from "./slices/favoritesSlice";
import invoices from "./slices/invoicesSlice";
import orderAgain from "./slices/orderAgainSlice";
import purchaseHistory from "./slices/purchaseHistorySlice";
import returns from "./slices/returnsSlice";
import subscriptions from "./slices/subscriptionsSlice";

const store = configureStore({
  reducer: {
    cart: cartReducer,
    brand,
    subscriptions,
    favorites,
    invoices,
    orderAgain,
    purchaseHistory,
    returns,
    bestSellers,
    classification,
    products,
    user,
    itemPriceAfterDiscount,
    recentViews,
  },
});

export default store;
